
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MFGTransactionItemsGrid extends Serenity.EntityGrid<MFGTransactionItemsRow, any> {
        protected getColumnsKey() { return 'Production.MFGTransactionItems'; }
        protected getDialogType() { return MFGTransactionItemsDialog; }
        protected getIdProperty() { return MFGTransactionItemsRow.idProperty; }
        protected getInsertPermission() { return MFGTransactionItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MFGTransactionItemsRow.localTextPrefix; }
        protected getService() { return MFGTransactionItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}